import { render, staticRenderFns } from "./DepositList.vue?vue&type=template&id=0f6c6ddd&"
import script from "./DepositList.vue?vue&type=script&lang=js&"
export * from "./DepositList.vue?vue&type=script&lang=js&"
import style0 from "./DepositList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VContainer,VDataTable,VPagination})
